







import { computed, defineComponent } from '@nuxtjs/composition-api';
import type { ComputedRef, PropType } from '@nuxtjs/composition-api';
import Breadcrumbs from '~/components/atoms/Breadcrumbs.vue';
import { Breadcrumb } from '~/types/components/Breadcrumbs/Breadcrumb';
import { prepareBreadcrumb } from '~/helpers/prepareBreadcrumb/prepareBreadcrumb';
import { ProductVariantExtended } from '~/types/product/ProductVariantExtended';
import { getBreadcrumbsFromProduct } from '~/helpers/category/getBreadcrumbsFromProduct';

export default defineComponent({
  name: 'ProductBreadcrumbs',
  components: {
    Breadcrumbs,
  },
  props: {
    product: {
      type: Object as PropType<ProductVariantExtended>,
      required: true,
    },
  },
  setup(props) {
    const breadcrumbsList: ComputedRef<Breadcrumb[]> = computed(() => {
      const breadcrumbs = getBreadcrumbsFromProduct(props.product);
      let res = [];

      try {
        breadcrumbs.forEach((breadcrumb, index) => {
          if (!breadcrumb.name || !breadcrumb.slug) {
            /** if the breadcrumbs are incomplete, do not display any of them */
            res = [];
            return;
          }
          res.push(
            prepareBreadcrumb(breadcrumb.name, breadcrumb.slug, index),
          );
        });
      } catch (e) {
        /** reset after error occurs */
        res = [];
      }

      return res;
    });

    return {
      breadcrumbsList,
    };
  },
});
